import config from "config";

export const CONTACT_REASON_TYPE = {
  AGE_VERIFICATION: 1,
  PAYMENT: 2,
  WITHDRAW: 3,
  OTHER: 4,
};

export const MEMBER_TYPE = {
  NORMAL: 1,
  POINT_USER: 2,
  PLAN_USER: 3,
  JOB_TRIAL: 5,
  JOB_MEMBER: 6,
};

export const MEMBER_STATUS = {
  ACTIVE: 0,
  IN_ACTIVE: 1,
  ALL: 2,
};

export const CHARA_STATUS = {
  USER: 0,
  CHARA: 1,
};

export const IMAGE_STATUS = {
  PENDDING: 1,
  CONFIRMED: 2,
  ALL: 3,
};

export const GENDER = {
  MALE: 1,
  FEMALE: 2,
};

export const PROFILE = {
  ROOT: 0,
};

export const ITEM_JOB_TYPE = {
  ROOT: 0,
};

export const SEARCH_TYPE = {
  DROPDOWN: 1,
  CHECKBOX: 2,
  RANGE: 3,
  TEXT: 4,
};

export const CAMPAIGN_TYPE = {
  PLAN: 1,
  POINT: 2,
  CONTACT: 3,
  AGE_VERIFICATION: 4,
  INFO1: 11,
  INFO2: 12,
  INFO3: 13,
  INFO4: 14,
  INFO5: 15,
  INFO6: 16,
  INFO7: 17,
  INFO8: 18,
};

export const PLACE_PAGE = {
  POINT: 1,
  PLAN: 2,
};

export const REGISTER_TYPE = {
  WEB: 1,
  APP: 2,
  CMS: 9,
};

export const JOB_ENTRY_MEMBER_LIST_TYPE = {
  TRAIL: 1,
  ENTRY: 2,
};

export const OTPAction = {
  Register: 0,
  Login: 1,
  ChangePhone: 2,
};

export const JOB_DETAIL_SHOW_ITEMS = {
  // JOB_TYPE: 1, // 0: Hidden, 1: Show
  // JOB_CATEGORY: 1, // 0: Hidden, 1: Show
  // SALARY_PAY_TYPE: 1, // 0: Hidden, 1: Show
  // SALARY_ESTIMATE: 1, // 0: Hidden, 1: Show
  SALARY_DETAIL: 1, // 0: Hidden, 1: Show
  WORK_HOURS: 1, // 0: Hidden, 1: Show
  LOCATION: 1, // 0: Hidden, 1: Show
};


export const SEARCH_USER_TRIAL_FILTER = 'search_user_trial_filter';
export const SEARCH_USER_FILTER = 'search_user_filter';
export const SEARCH_AGENT_FILTER = 'search_agent_filter';
export const SEARCH_JOB_FILTER = 'search_job_filter';
export const SEARCH_JOB_TRIAL_FILTER = 'search_job_trial_filter';

export const STATE_USER_TASK_ACTION = '_user_se_';
export const AUTH_TOKEN = 'token';
export const AUTH_TOKEN_ADMIN = 'token_admin';
export const AUTH_TOKEN_WEB = 'token_web'; // Admin show profile user, set override token

export const LINK_DISPLAY_PAGE_AFTER_LOGIN = {
  1: `/web/home`,
  2: `/web/mypage`,
  3: `/web/mypage-job`,
  4: `/web/job-lp`,
};

export const DEFINED_TYPE_LINKS = {
  BLOG_OTHER: 'blog_other',
  BLOCK_LIST: 'block_list',
  PROFILE_EDIT: 'profile_edit',
  FAVORITE_JOB: 'favorite_job',
  MY_PROFILE: 'my_profile',
  SEARCH_USER: 'search_user',
  SEARCH_AGENT: 'search_agent',
  SEARCH_JOB: 'search_job',
  JOB_ENTRY_LIST: 'job_entry_list',
  CHAT_ROOM: 'chat_room',
  CHAT_SUPPORT: 'chat_support',
  BLOG_EDIT: 'blog_edit',
  CHAT_AGENT: 'chat_agent',
  FAVORITE_USER: 'favorite_user',
  LIKE: 'like',
  FOOTPRINT: 'footprint',
  SEARCH_USER_TRIAL: 'search_user_trial',
};

export const ACCESS_PAGE_LINK_STICKY_CONTENT_TYPE = [
  DEFINED_TYPE_LINKS.CHAT_ROOM,
  DEFINED_TYPE_LINKS.CHAT_SUPPORT,
  DEFINED_TYPE_LINKS.BLOG_EDIT,
  DEFINED_TYPE_LINKS.BLOG_OTHER,
  DEFINED_TYPE_LINKS.SEARCH_USER,
  DEFINED_TYPE_LINKS.SEARCH_AGENT,
  DEFINED_TYPE_LINKS.SEARCH_JOB,
  DEFINED_TYPE_LINKS.PROFILE_EDIT,
  DEFINED_TYPE_LINKS.BLOCK_LIST,
  DEFINED_TYPE_LINKS.FAVORITE_JOB,
  DEFINED_TYPE_LINKS.MY_PROFILE,
  DEFINED_TYPE_LINKS.JOB_ENTRY_LIST,
  DEFINED_TYPE_LINKS.CHAT_AGENT,
  DEFINED_TYPE_LINKS.CHAT_ROOM,
  DEFINED_TYPE_LINKS.FAVORITE_USER,
  DEFINED_TYPE_LINKS.LIKE,
  DEFINED_TYPE_LINKS.FOOTPRINT,
  DEFINED_TYPE_LINKS.SEARCH_USER_TRIAL
];

export const NUMBER_RANGE_YEAR_REGISTER = 80;

export const DISPLAY_ELEMENT_TYPE = {
  ON: 0,
  NOT_LINK: 1,
  HIDDEN: 2,
};

export const DISPLAY_BUTTON = {
  SHOW: 0,
  HIDDEN: 1,
};


export const SHOW_STATUS = {
  SHOW: 0,
  ONLY_MALE: 1,
  ONLY_FEMALE: 2,
  ONLY_USER: 3,
  ONLY_CHARACTER: 4,
  HIDDEN: 9,
};

export const GENDER_STATUS = {
  MALE: 1,
  FEMALE: 2,
};

export const CHARACTER_STATUS = {
  USER: 0,
  CHARACTER: 1,
};

export const DIR_FOLDER_IMAGE = {
  CHAT: 'chat',
  CHAT_SUPPORT: 'chat_support_individual',
  CHAT_AGENT: 'chat_agent_individual',
  BLOG: 'blog',
  CONTACT_AFTER_LOGIN: 'contact_afterlogin',
  CONTACT_AGE: 'contact_age',
  PROFILE_MEMBER: 'profile_member',
  CONTACT_BEFORE_LOGIN: 'contact_nologin',
  POPUP: 'popup',
  CAMPAIGN: 'campaign',
  INFO_ADMIN: 'information_admin',
};

export const PHONE_NUMBER_REGEX = /^\+?([0-9+\s-]{9,})$/;
export const EMAIL_REGEX = /^([0-9+\s-]{8,13})$|^(\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+)$/;

export const OTP_TYPE = {
  OTP: 0,
  NO_OTP: 1,
};

export const OTP_VERIFY_STATUS = {
  OTPNotVerified: 0,
  OTPVerified: 1,
}

export const READ_MESSAGE_CHAT_STATUS = {
  UNREAD: 0,
  READ: 1,
}


export const RELIPED_MESSAGE_CHAT_STATUS = {
  UNRELIPED: 0,
  RELIPED: 1,
}

export const STATUS_SMS_OTP = {
  DELIVERED: 0,
  FAILED: 1,
  REJECTED: 12,
  UNKNOWN: 11,
}

export const TYPE_LOGIN = {
  PHONE: 1,
  EMAIL: 2,
};

export const TYPE_DEVICE = {
  CMS: 1,
  WEB: 2,
  APP: 3,
}

export const ERROR_404_ROUTE = '/error/404'

export const AUTH_CONTEXT_KEYS = {
      ENV_UI: 'envUi',
      RESOURCE_PROFILE: 'resourceProfile',
      PROFILE_META: 'profileMeta',
      USER_PROFILE: 'userProfile',
      CAMPAIGNS: 'campaigns',
      POPUPS: 'popups',
};

